import type { ReactNode } from 'react';

export const symbol_currency_lira: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M370-150v-194l-84 52q-15 9-30.5 1T240-317q0-8 3.5-14.5T254-343l116-72v-118l-85 53q-15 9-30 .5T240-506q0-8 3.5-14.5T254-531l116-73v-206q0-13 8.5-21.5T400-840q13 0 21.5 8.5T430-810v168l125-78q15-9 30-.5t15 26.5q0 8-3.5 14.5T586-669l-156 98v118l125-78q15-9 30-.5t15 26.5q0 8-3.5 14.5T586-480l-156 98v202h19q82 0 140-49.5T658-354q2-12 11-19t21-7q12 0 21 7.5t7 18.5q-12 101-87.5 167.5T450-120h-50q-13 0-21.5-8.5T370-150Z"
		/>
	</svg>
);
